
import { ref } from "@vue/reactivity";
export default {
  components: {},
  setup() {
    const job = ref<any>(JSON.parse(localStorage.jobDetail));
    return {
      job,
    };
  },
};
